const TZ = 'Asia/Shanghai'
const WEEK_TEXT = ['日', '一', '二', '三', '四', '五', '六']

export function formatTime(value, format = 'HH:mm') {
  if (!value) return ''
  const date = parseDate(value)
  if (!date) return ''
  return formatDate(date, format)
}

export function formatDateTitle(item) {
  if (item.schedule_date_format && item.schedule_week) {
    return `${item.schedule_date_format} ${item.schedule_week}`
  }
  const date = parseDate(item.schedule_date)
  if (!date) return item.schedule_date || ''
  const parts = getBeijingParts(date)
  return `${pad(parts.month)}月${pad(parts.day)}日 周${WEEK_TEXT[getBeijingWeekdayIndex(date)]}`
}

export function formatNewsTime(value) {
  if (!value) return ''
  const publish = parseDate(value)
  if (!publish) return value
  const now = new Date()
  if (isSameDay(publish, now)) {
    const minute = Math.floor((now.getTime() - publish.getTime()) / 60000)
    if (minute < 60) return `${Math.max(minute, 1)} 分钟前`
    return `${Math.floor(minute / 60)} 小时前`
  }
  const todayStart = startOfBeijingDay(now)
  const yesterdayStart = new Date(todayStart.getTime() - 86400000)
  if (publish.getTime() >= yesterdayStart.getTime() && publish.getTime() < todayStart.getTime()) {
    return '昨天'
  }
  return formatDate(publish, 'YYYY-MM-DD')
}

export function formatNewsDetailTime(value) {
  return formatTime(value, 'YYYY-MM-DD HH:mm')
}

function parseDate(value) {
  if (!value) return null
  const text = String(value).trim()
  if (!text) return null

  const normalized = text.replace(/\./g, '-').replace(/\//g, '-')
  const match = normalized.match(/^(\d{4})-(\d{1,2})-(\d{1,2})(?:[ T](\d{1,2}):(\d{1,2})(?::(\d{1,2}))?)?/)
  if (match) {
    const iso = `${match[1]}-${pad(+match[2])}-${pad(+match[3])}T${pad(+(match[4] || 0))}:${pad(+(match[5] || 0))}:${pad(+(match[6] || 0))}+08:00`
    const date = new Date(iso)
    return Number.isNaN(date.getTime()) ? null : date
  }

  const fallback = new Date(text.replace(/-/g, '/'))
  return Number.isNaN(fallback.getTime()) ? null : fallback
}

function getBeijingParts(date) {
  const parts = new Intl.DateTimeFormat('en-GB', {
    timeZone: TZ,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false
  }).formatToParts(date)

  const pick = type => {
    const item = parts.find(part => part.type === type)
    return item ? Number(item.value) : 0
  }

  return {
    year: pick('year'),
    month: pick('month'),
    day: pick('day'),
    hour: pick('hour'),
    minute: pick('minute')
  }
}

function getBeijingWeekdayIndex(date) {
  const weekday = new Intl.DateTimeFormat('en-US', {
    timeZone: TZ,
    weekday: 'short'
  }).format(date)
  const map = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 }
  return map[weekday] !== undefined ? map[weekday] : 0
}

function startOfBeijingDay(date) {
  const parts = getBeijingParts(date)
  return new Date(`${parts.year}-${pad(parts.month)}-${pad(parts.day)}T00:00:00+08:00`)
}

function isSameDay(left, right) {
  const a = getBeijingParts(left)
  const b = getBeijingParts(right)
  return a.year === b.year && a.month === b.month && a.day === b.day
}

function formatDate(date, format) {
  const parts = getBeijingParts(date)
  const map = {
    YYYY: parts.year,
    MM: pad(parts.month),
    DD: pad(parts.day),
    HH: pad(parts.hour),
    mm: pad(parts.minute)
  }
  return format.replace(/YYYY|MM|DD|HH|mm/g, key => map[key])
}

function pad(value) {
  return String(value).padStart(2, '0')
}
